AC_SERVICES.addListener('Table.Ready', () => {
    var _a, _b;
    const numElement = document.querySelector('.tablenav-pages .displaying-num');
    if (numElement) {
        let numberFormatted = numElement.innerHTML.split(' ')[0];
        let number = numElement.innerHTML.replace(/\D/g, '');
        if (typeof ACP_Export !== 'undefined') {
            ACP_Export.total_num_items = number;
        }
        (_b = (_a = AC_SERVICES.getService('Editing')) === null || _a === void 0 ? void 0 : _a.getService('BulkSelectionRow')) === null || _b === void 0 ? void 0 : _b.setTotalItems(parseInt(number), numberFormatted);
    }
});
export {};
